export default __webpack_public_path__ + "static/store-galaxy.zh-hant-d6bc9c75dc79846b22c099d5aca76000.png";